/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Proposal_TitleInputs */

const en_home_proposal_title = /** @type {(inputs: Home_Proposal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We need a <u>pause</u>`)
};

/**
* | output |
* | --- |
* | "We need a <u>pause</u>" |
*
* @param {Home_Proposal_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_proposal_title = /** @type {((inputs?: Home_Proposal_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Proposal_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_proposal_title(inputs)
});